import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

/** Smart "Recommended Next Step" card for the main dashboard. */
export default function RecommendedNextStep() {
  const [step, setStep] = useState(null);

  useEffect(() => {
    api.get("/tour/next-step").then((r) => setStep(r.data)).catch(() => {});
  }, []);

  if (!step || step.key === "done") return null;

  return (
    <div className="rounded-xl border border-brand-cyan/30 bg-brand-cyan/5 p-5 flex flex-wrap items-center gap-4"
      data-testid="recommended-next-step">
      <div className="h-10 w-10 rounded-lg bg-brand-cyan/15 border border-brand-cyan/40 flex items-center justify-center shrink-0">
        <Lightbulb className="h-5 w-5 text-brand-cyan" />
      </div>
      <div className="min-w-[180px] flex-1">
        <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-brand-cyan mb-0.5">// Recommended next step</div>
        <div className="text-sm font-bold text-ink-primary" data-testid="next-step-title">{step.title}</div>
        <div className="text-[11px] text-ink-muted">{step.description}</div>
      </div>
      <Link to={step.link} data-testid="next-step-cta"
        className="inline-flex items-center gap-1.5 rounded-lg bg-brand-cyan px-4 py-2 text-xs font-bold text-black hover:opacity-90 transition shrink-0">
        {step.cta} <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
